var stampedReviewList;
function loadReviewImageSlider(){
    $.ajax({
        type: "GET",
        url: "https://stamped.io/api/widget/reviews?tags=recommend&storeUrl=the-guu-shop.myshopify.com&apiKey=pubkey-wC98NvWez853Oi4V120J9lMEe571Ot",
        dataType: "json",
        success: function(t) {
            stampedReviewList = t.data;

            var itemStr="<div class=\"logo-bar guu-review-slider-container\">";
            stampedReviewList.forEach(function( val, index ) {
                var urls = val.reviewUserPhotos.split(',');
                var url = urls[0];
                itemStr +="<a href='#' onclick='return false;' data-index='"+index+"' data-index-photo='0' class=\"logo-bar__item review-slider-item carousel-cell\"><img class='logo-bar-square lazyload' src=\"https://cdn.shopify.com/s/files/1/0057/1018/4551/files/GUU_Jewerly.png?v=1569744436\" data-src=\"https://cdn.stamped.io/uploads/photos/"+url+"?tr=h-300\" alt=\"\" class=\"logo-bar-square logo-bar__image\"></a>";
            });
            itemStr+="</div>";
            $('#guu-review-slider').html(itemStr)
            $('.guu-review-slider-container').flickity({
                // options
                cellAlign: 'left',
                contain: false,
                pageDots:false,
                prevNextButtons:false,
                freeScroll:true,
                wrapAround:true,
                adaptiveHeight:false,
                on: {
                    staticClick: function(event, pointer, cellElement, cellIndex) {
                        var self = $(cellElement)
                        var mediaIdx = self.attr('data-index');
                        var photoIdx = self.attr('data-index-photo');
                        StampedFn.openUGCModal(stampedReviewList, mediaIdx, $('html'), null, null, photoIdx);
                    },

                }

            });

        }
    })
}
$(document).ready(function() {
    loadReviewImageSlider()
})